import styled from "styled-components";
import { PlayIcon, RefreshIcon } from "@8x8/oxygen-icon";
import { COLORS } from "@/react/theme/constants";
import Button from "@8x8/oxygen-button";

export const ContainerBody = styled.div`
  border: 1px solid ${COLORS.tertiary};
  padding-top: 12px;
  border-radius: 8px;
`;

export const Paragraph = styled.p`
  padding: 0 12px;
`;

export const ActionButton = styled(Button)`
  margin-right: 8px;
`;

export const ActionsContainer = styled.div`
  border-top: 1px solid ${COLORS.tertiary};
  background: ${COLORS.gray10};
  padding: 12px;
`;

export const StyledRefreshIcon = styled(RefreshIcon)`
  margin-right: 4px;
`;

export const StyledPlayIcon = styled(PlayIcon)`
  margin-right: 4px;
`;

export const LastRefreshSpan = styled.span`
  margin-left: 4px;
`;
